import React, { useEffect, useRef, useState } from "react";
import GirlImage2 from "../../images/LandingPageImage/Contact 1.png";
import address from "../../images/LandingPageImage/marker-02.svg";
import call from "../../images/LandingPageImage/phone-call-01.svg";
import icon from "../../images/LandingPageImage/icon.png";
import FaqSection from "./FAQ";
import Footer from "./Footer";
import Navbar from "./Navbar";
import useContactForm from "../../services/LandingPage/useContactForm";
import { ToastContainer } from "react-toastify";

const Contact = () => {
  const { submitEnquiryDetails, loading } = useContactForm();
  const formRef = useRef(null);

  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
    email: "",
    enquiryType: "",
    description: "",
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [apiError, setApiError] = useState("");

  useEffect(() => {
    const currentUrl = window.location.href;
    const encodedUrl = encodeURIComponent(currentUrl);
    const script = document.createElement("script");
    script.src = `https://anlook.com/SeoBix/seo_injection.php?webid=56c53e1ff4273fa3746b406c70f5bf9c&url=${encodedUrl}&baseUrl=https%3A%2F%2Fanlook.com`;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phoneNumber") {
      const onlyDigits = value.replace(/\D/g, "").slice(0, 10);
      setFormData((prev) => ({
        ...prev,
        [name]: onlyDigits,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setApiError("");
    setSuccessMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSuccessMessage("");
    setApiError("");

    const form = new FormData(e.target);

    const latestFormData = {
      fullName: (form.get("fullName") || "").toString().trim(),
      phoneNumber: (form.get("phoneNumber") || "")
        .toString()
        .replace(/\D/g, "")
        .slice(0, 10),
      email: (form.get("email") || "").toString().trim(),
      enquiryType: (form.get("enquiryType") || "").toString().trim(),
      description: (form.get("description") || "").toString().trim(),
    };

    setFormData(latestFormData);

    const newErrors = {};

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^[0-9]{10}$/;

    if (!latestFormData.fullName) {
      newErrors.fullName = "Full name is required";
    }

    if (!latestFormData.phoneNumber) {
      newErrors.phoneNumber = "Phone number is required";
    } else if (!mobileRegex.test(latestFormData.phoneNumber)) {
      newErrors.phoneNumber = "Phone number must be exactly 10 digits";
    }

    if (!latestFormData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(latestFormData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!latestFormData.enquiryType) {
      newErrors.enquiryType = "Please select inquiry type";
    }

    if (!latestFormData.description) {
      newErrors.description = "Description is required";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    const result = await submitEnquiryDetails(latestFormData);

    if (result.success) {
      setSuccessMessage(result.message || "Inquiry submitted successfully");
      setFormData({
        fullName: "",
        phoneNumber: "",
        email: "",
        enquiryType: "",
        description: "",
      });
      setErrors({});
      e.target.reset();
    } else {
      setApiError(result.message || "Something went wrong");
    }
  };

  return (
    <>
      <Navbar />
      <ToastContainer/>
      
      <div className=" min-h-screen">
        <div className="bg-[#e6f7ff]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="relative overflow-hidden flex flex-col lg:flex-row items-center justify-start py-10 lg:py-12 min-h-[450px]">
              <div className="w-full lg:w-1/2 flex flex-col justify-center lg:pr-12 z-30 mb-10 lg:mb-0">
                <h2 className="m-0 p-0 text-[40px] font-bold leading-tight text-[#0c4d45] font-dm">
                  Get in Touch!
                </h2>

                <p className="pt-4 max-w-[420px] text-[18px] md:text-[20px] leading-relaxed text-black font-dm">
                  To contact us, simply click on the WhatsApp button located at
                  the bottom right of any page on our website and you can also
                  reach out to us via email.
                </p>
              </div>

              <div className="w-full lg:w-1/2 h-full lg:absolute lg:right-0 lg:top-0 lg:bottom-0 z-10 flex justify-end items-end">
                <div className="absolute inset-0 pointer-events-none z-0 hidden lg:block" />

                <img
                  src={GirlImage2}
                  alt="Contact"
                  className="w-[280px] sm:w-[350px] lg:w-[500px] max-w-full h-auto object-contain relative z-20 mb-[-20px]"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-[#0C4D45] to-[#02C37D] py-20 px-4">
          <div className="mx-auto max-w-7xl">
            <div className="grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3">
              <div className="rounded-[16px] bg-white px-8 py-12 text-center shadow-sm">
                <div className="mb-4 flex justify-center">
                  <img src={address} alt="Email" className="h-10 w-10" />
                </div>

                <p className="mb-3 text-[18px] font-semibold text-[#0a7c66]">
                  Visit us
                </p>

                <p className="text-[16px] leading-[1.6] text-gray-700">
                  <span className="block">
                    Ithum Tower, Tower-B, 218, Second Floor
                  </span>
                  <span className="block">Sector 62 Noida-201309</span>
                </p>
              </div>

              <div className="rounded-[16px] bg-white px-8 py-12 text-center shadow-sm">
                <div className="mb-4 flex justify-center">
                  <img src={icon} alt="address" className="h-10 w-10" />
                </div>

                <p className="mb-3 text-[18px] font-semibold text-[#0a7c66]">
                  Chat to support
                </p>

                <p className="text-[16px] text-gray-700">support@anlook.com</p>
              </div>

              <div className="rounded-[16px] bg-white px-8 py-12 text-center shadow-sm">
                <div className="mb-4 flex justify-center">
                  <img src={call} alt="call" className="h-10 w-10" />
                </div>

                <p className="mb-3 text-[18px] font-semibold text-[#0a7c66]">
                  Call us
                </p>

                <p className="text-[16px] text-gray-700">+91-9958853167</p>
              </div>
            </div>
          </div>
        </div>

        <section className="w-full bg-sky-50 px-4 py-16 md:px-8 lg:px-16 xl:px-24">
          <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-2">
            <div className="max-w-xl">
              <h2 className="text-[34px] font-bold leading-[1.35] text-green-900 sm:text-[42px]">
                Let’s Build Your WhatsApp
                <br />
                Automation
              </h2>

              <p className="mt-6 text-[18px] leading-[1.9] text-[#3f3f46]">
                Share your requirements and inquiry, Our Team will help you
                automate conversations, boost engagement and grow faster.
              </p>

              <div className="mt-8 space-y-6 text-[18px] text-[#6b7280]">
                <p className="flex items-center gap-3">
                  <span className="text-black">✓</span>
                  Trusted by 500+ businesses
                </p>
                <p className="flex items-center gap-3">
                  <span className="text-black">✓</span>
                  Response within 24 hours
                </p>
                <p className="flex items-center gap-3">
                  <span className="text-black">✓</span>
                  Boost customer engagement instantly
                </p>
                <p className="flex items-center gap-3">
                  <span className="text-black">✓</span>
                  No coding required to get started
                </p>
              </div>
            </div>

            <div className="rounded-[14px] border border-green-500 bg-white p-6 sm:p-8">
              <h3 className="text-center text-[24px] font-semibold text-green-500">
                Send an inquiry
              </h3>

              <p className="mt-4 text-center text-[16px] text-[#4b5563]">
                fill in your details and we’ll get back to you.
              </p>

              <form
                ref={formRef}
                className="mt-8 space-y-5"
                onSubmit={handleSubmit}
              >
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <input
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      placeholder="Full Name"
                      autoComplete="name"
                      className="h-[54px] w-full rounded-[12px] border border-gray-300 bg-[#f7f7f7] px-4 text-[16px] text-[#667085] outline-none placeholder:text-[#667085] focus:border-[#10c26f]"
                    />
                    {errors.fullName && (
                      <p className="mt-1 text-sm text-red-500">
                        {errors.fullName}
                      </p>
                    )}
                  </div>

                  <div>
                    <input
                      type="text"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      placeholder="Phone Number"
                      maxLength={10}
                      autoComplete="tel"
                      className="h-[54px] w-full rounded-[12px] border border-gray-300 bg-[#f7f7f7] px-4 text-[16px] text-[#667085] outline-none placeholder:text-[#667085] focus:border-[#10c26f]"
                    />
                    {errors.phoneNumber && (
                      <p className="mt-1 text-sm text-red-500">
                        {errors.phoneNumber}
                      </p>
                    )}
                  </div>
                </div>

                <div>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email Address"
                    autoComplete="email"
                    className="h-[54px] w-full rounded-[12px] border border-gray-300 bg-[#f7f7f7] px-4 text-[16px] text-[#667085] outline-none placeholder:text-[#667085] focus:border-[#10c26f]"
                  />
                  {errors.email && (
                    <p className="mt-1 text-sm text-red-500">{errors.email}</p>
                  )}
                </div>

                <div>
                  <select
                    name="enquiryType"
                    value={formData.enquiryType}
                    onChange={handleChange}
                    className="h-[54px] w-full rounded-[12px] border border-gray-300 bg-[#f7f7f7] px-4 text-[16px] text-[#667085] outline-none focus:border-[#10c26f]"
                  >
                    <option value="" disabled>
                      Select Inquiry Type
                    </option>
                    <option value="Demo Request">Demo Request</option>
                    <option value="Pricing">Pricing</option>
                    <option value="Support">Support</option>
                    <option value="Partnership">Partnership</option>
                    <option value="enquiry">Enquiry</option>
                    <option value="feature">Feature</option>
                  </select>
                  {errors.enquiryType && (
                    <p className="mt-1 text-sm text-red-500">
                      {errors.enquiryType}
                    </p>
                  )}
                </div>

                <div>
                  <textarea
                    rows="5"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Tell us about your requirement..."
                    autoComplete="off"
                    className="w-full rounded-[12px] border border-gray-300 bg-[#f7f7f7] px-4 py-4 text-[16px] text-[#667085] outline-none placeholder:text-[#667085] focus:border-[#10c26f]"
                  />
                  {errors.description && (
                    <p className="mt-1 text-sm text-red-500">
                      {errors.description}
                    </p>
                  )}
                </div>

                {apiError && (
                  <p className="text-center text-sm font-medium text-red-500">
                    {apiError}
                  </p>
                )}

                {successMessage && (
                  <p className="text-center text-sm font-medium text-green-600">
                    {successMessage}
                  </p>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className="h-[52px] w-full rounded-[12px] bg-green-500 text-[20px] font-semibold text-white transition hover:bg-green-600 disabled:cursor-not-allowed disabled:opacity-70"
                >
                  {loading ? "Submitting..." : "Send Inquiry"}
                </button>
              </form>
            </div>
          </div>
        </section>

        <FaqSection />
        <Footer />
      </div>
    </>
  );
};

export default Contact;